'use strict'

export function getFilterIcon (filterName, filterType, filterKey, filterSelectedMode) {
  if (filterName === 'alarm' && filterKey === 'objectType') {
    return 'mdi-lightbulb-outline'
  }

  if (filterName === 'serviceObject' && filterKey === 'type') {
    return 'mdi-traffic-cone'
  }

  switch (filterKey) {
    case 'targetProgram':
      return 'mdi-target'
    case 'applicantDescr':
      return 'mdi-text-long'
    case 'bpStateName':
    case 'requestBPState':
    case 'reportBPState':
      return 'mdi-google-nearby'
    case 'roadsStatus':
      return 'mdi-road'
    case 'objectRegion':
      return 'mdi-map-marker-circle'
    case 'objectAddress':
      return 'mdi-city'
    case 'initialSource':
      return 'mdi-inbox-arrow-down'
    case 'type':
      return 'mdi-hammer-wrench'
    case 'totalPriority':
      return 'mdi-alert-octagon'
    case 'objectType':
      return 'mdi-traffic-cone'
    case 'origin':
      return 'mdi-lightbulb-outline'
    case 'externalName':
      return 'mdi-road'
    case 'objectNumber':
      return 'mdi-traffic-cone'
    case 'externalId':
      return 'mdi-road'
    case 'performedByContractor':
      return 'mdi-account-hard-hat'
    case 'responsiblePerformer':
      return 'mdi-account-hard-hat'
    case 'onlyActive':
      return 'mdi-timelapse'
    case 'excludeClosed':
      return 'mdi-archive'
    case 'name':
      return 'mdi-numeric'
    case 'fvfComplexNumber':
      return 'mdi-traffic-cone'
    case 'requestStatus':
      return 'mdi-google-nearby'
    case 'monitoringStatus':
      return 'mdi-google-nearby'
    case 'patterns':
      return 'mdi-magnify'
    case 'serviceObjectNumber':
      return 'mdi-traffic-cone'
    case 'requestType':
      return 'mdi-hammer-wrench'
    case 'acceptedWithCheck':
      return 'mdi-account-check'
    case 'hasDebits':
      return 'mdi-briefcase'
    case 'debitsApproved':
      return 'mdi-briefcase-check'
    case 'approvedUserFIO':
      return 'mdi-account-check'
    case 'revisionUserFIO':
      return 'mdi-account-remove'
    case 'photo':
      return 'mdi-image-area'
    case 'brigade':
    case 'brigadeEmployees':
      return 'mdi-account-hard-hat'
    case 'brigadier':
      return 'mdi-account-hard-hat'
    case 'requestNumber':
      return 'mdi-numeric'
    case 'workArea':
      return 'mdi-wrench-outline'
    case 'brigadeName':
      return 'mdi-account-hard-hat'
    case 'workShift':
      return 'mdi-clock-outline'
    case 'number':
      return 'mdi-traffic-cone'
    case 'address':
      return 'mdi-city'
    case 'region':
      return 'mdi-map-marker-circle'
    case 'routeNeighborhood':
      return 'mdi-vector-polygon'
    case 'polygon':
      return 'mdi-vector-polygon'
    case 'baseProject':
      return 'mdi-text-box'
    case 'onlyGosContract':
      return 'mdi-text-box'
    case 'deviceIp':
      return 'mdi-ip-network-outline'
    case 'actual':
      return 'mdi-traffic-cone'
    case 'severity':
      return 'mdi-alert-octagon'
    case 'workTypes':
      return 'mdi-wrench'
    case 'workTypesDone':
      return 'mdi-wrench'
    case 'project':
      return 'mdi-file-star-outline'
    default:
      if (filterType === 'list') {
        return 'mdi-format-list-bulleted-square'
      } else if (filterType === 'string') {
        return 'mdi-text-short'
      } else if (filterType === 'number' || filterType === 'integer') {
        return 'mdi-numeric'
      } else if (filterType === 'select') {
        return 'mdi-format-list-checks'
      } else if (filterType === 'date') {
        switch (filterSelectedMode) {
          case 'last':
          case 'lastNoYear':
          case 'nextNoYear':
          case 'leftLess':
          case 'leftMore':
          case 'overdueLess':
          case 'overdueMore':
          case 'present':
          case 'absent':
          case 'any':
            return 'mdi-timer-sand'
          case 'interval':
          case 'intervalNoYear':
            return 'mdi-calendar-range'
          default:
            return 'mdi-calendar'
        }
      }
  }
}
